const build = `{
  "require": {
      "stripe/stripe-php": "^7.56.0"
  }
}
`;

export default {
  build,
};
